import { Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import Footer from './Layout/Footer/Footer';
import Header from './Layout/Header/Header';
import './Vendor.js'
import Index from './pages/Index/index1';
import { Fragment } from 'react';
import Index9 from './pages/Index/index9';
import Invoice from './pages/shop/Invoice';
import ComingSoon from './pages/utilities/comingsoon';
import Maintenance from './pages/utilities/maintenance';
import PageNotFound from './pages/utilities/404';
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import Scrolltop from './Layout/Header/BackToTop';

function App(props) {
  const location = useLocation();
  const getUrl = (pathname) => {
    let pathArray = pathname.split('/');
    return `/${pathArray[1]}` === '/coming-soon'
      ? true
      : `/${pathArray[1]}` === '/maintenance'
        ? true
        : `/${pathArray[1]}` === '/page-not-found'
          ? true
          : false;
  };

  const scrollbarStyle = `
    ::-webkit-scrollbar {
      display: none;
    }
  `;

  return (
    <>

      <Fragment>

        <style>{scrollbarStyle}</style>

        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        
        {getUrl(location.pathname) ?
          <Routes>
            // <Route path="/coming-soon" element={<ComingSoon />} />
            // <Route path="/maintenance" element={<Maintenance />} />
            <Route path="/page-not-found" element={<PageNotFound />} />
          </Routes> :
          <div className="page-wrapper">
            <Routes>
              <Route path="/invoice/siskoe" element={<Invoice   />} />
              <Route exact path="/" element={<Index9 />} />
            </Routes>

            <Footer />
            <Scrolltop />

          </div>
        }
      </Fragment>
    </>
  );
}

export default App;
